// export const CREATE_PAYMENT_URL = graphql(`
//   mutation createPaymentUrl($input: InputCreatePaymentLink!) {
//     createPaymentUrl(input: $input)
//   }
// `);

import { graphql } from '@/.gql';

// export const CREATE_PAYMENT = graphql(`
//   mutation createPayment($input: InputPayment!) {
//     createPayment(input: $input) {
//       ...TPayment
//     }
//   }
// `);

export const ANSWER_WEB_APP_QUERY = graphql(`
  mutation answerWebAppQuery($initData: String!) {
    answerWebAppQuery(initData: $initData)
  }
`);

export const SEND_KEYBOARD = graphql(`
  mutation sendKeyboard($keyboard: String!) {
    sendKeyboard(keyboard: $keyboard)
  }
`);

export const GENERATE_STYLE = graphql(`
  mutation generateStyle(
    $styleId: String!
    $loraId: String!
    $resolution: String!
  ) {
    generateStyle(styleId: $styleId, loraId: $loraId, resolution: $resolution) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_PHOTO_SESSION = graphql(`
  mutation generatePhotoSession(
    $photoSessionId: String!
    $loraId: String!
    $resolution: String!
  ) {
    generatePhotoSession(
      photoSessionId: $photoSessionId
      loraId: $loraId
      resolution: $resolution
    ) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_PHOTO_SESSION_PHOTO = graphql(`
  mutation generatePhotoSessionPhoto(
    $image: Upload!
    $photoSessionId: String!
    $resolution: String!
  ) {
    generatePhotoSessionPhoto(
      image: $image
      photoSessionId: $photoSessionId
      resolution: $resolution
    ) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_VIDEO_LOOK = graphql(`
  mutation generateVideoLook(
    $videoLookId: String!
    $loraId: String!
    $resolution: String!
  ) {
    generateVideoLook(
      videoLookId: $videoLookId
      loraId: $loraId
      resolution: $resolution
    ) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_VIDEO_VEO3 = graphql(`
  mutation generateVideoVeo3($videoVeo3Id: String!, $userPrompt: String!) {
    generateVideoVeo3(videoVeo3Id: $videoVeo3Id, userPrompt: $userPrompt) {
      queueNum
      queueTime
    }
  }
`);

export const ANIMATE_PHOTO = graphql(`
  mutation animatePhoto(
    $prompt: String!
    $image: Upload!
    $resolution: String!
  ) {
    animatePhoto(prompt: $prompt, image: $image, resolution: $resolution) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_VIDEO_STYLE = graphql(`
  mutation generateVideoStyle(
    $videoStyleId: String!
    $image: Upload!
    $resolution: String!
  ) {
    generateVideoStyle(
      videoStyleId: $videoStyleId
      image: $image
      resolution: $resolution
    ) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_COMBI_VIDEO = graphql(`
  mutation generateCombiVideo(
    $combiVideoId: String!
    $loraId: String!
    $image: Upload!
    $resolution: String!
  ) {
    generateCombiVideo(
      combiVideoId: $combiVideoId
      loraId: $loraId
      image: $image
      resolution: $resolution
    ) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_PHOTO_BY_PHOTO = graphql(`
  mutation photoByPhoto(
    $referenceImage: Upload!
    $userImage: Upload!
    $publicationId: String
  ) {
    photoByPhoto(
      referenceImage: $referenceImage
      userImage: $userImage
      publicationId: $publicationId
    ) {
      queueNum
      queueTime
    }
  }
`);

export const GENERATE_EFFECT = graphql(`
  mutation generateEffect(
    $effectId: String!
    $resolution: String!
    $images: [Upload!]!
    $gender: Gender!
    $userName: String
    $accessory: String
  ) {
    generateEffect(
      effectId: $effectId
      resolution: $resolution
      images: $images
      gender: $gender
      userName: $userName
      accessory: $accessory
    ) {
      queueNum
      queueTime
    }
  }
`);

export const INPAINT_IMAGE_GENERATION = graphql(`
  mutation inpaintImageGeneration(
    $imageGenerationId: String!
    $imageIndex: Int!
    $mask: Upload!
    $prompt: String!
  ) {
    inpaintImageGeneration(
      imageGenerationId: $imageGenerationId
      imageIndex: $imageIndex
      mask: $mask
      prompt: $prompt
    ) {
      queueNum
      queueTime
    }
  }
`);

export const INPAINT_IMAGE = graphql(`
  mutation inpaintImage($image: Upload!, $mask: Upload!, $prompt: String!) {
    inpaintImage(image: $image, mask: $mask, prompt: $prompt) {
      queueNum
      queueTime
    }
  }
`);

export const UPDATE_PROFILE_BOTNAME = graphql(`
  mutation updateProfileBotName($botName: String!) {
    updateProfileBotName(botName: $botName)
  }
`);

export const SEND_FREE_STICKER_PACK = graphql(`
  mutation SendFreeStickerPack($effectId: String!) {
    sendFreeStickerPack(effectId: $effectId)
  }
`);

export const GOD_GENERATION_IMAGE = graphql(`
  mutation godGeneratonImage(
    $prompt: String!
    $loraId: String!
    $resolution: String!
  ) {
    godGeneratonImage(
      prompt: $prompt
      loraId: $loraId
      resolution: $resolution
    ) {
      queueNum
      queueTime
    }
  }
`);

export const SAVED_PUBLICATION = graphql(`
  mutation savedPublication($publicationId: String!) {
    savedPublication(publicationId: $publicationId) {
      ...TPublication
    }
  }
`);

export const UNSAVED_PUBLICATION = graphql(`
  mutation unsavedPublication($publicationId: String!) {
    unsavedPublication(publicationId: $publicationId) {
      ...TPublication
    }
  }
`);

export const PUBLICATION_FILE = graphql(`
  mutation publicationFile($fileId: String!) {
    publicationFile(fileId: $fileId) {
      ...TPublication
    }
  }
`);

export const UNPUBLICATION_FILE = graphql(`
  mutation unpublicationFile($fileId: String!) {
    unpublicationFile(fileId: $fileId) {
      ...TPublication
    }
  }
`);

export const SUBSCRIBE_USER = graphql(`
  mutation subscribeUser($publisherId: String!) {
    subscribeUser(publisherId: $publisherId) {
      ...TUser
    }
  }
`);
export const UNSUBSCRIBE_USER = graphql(`
  mutation unsubscribeUser($publisherId: String!) {
    unsubscribeUser(publisherId: $publisherId) {
      ...TUser
    }
  }
`);

export const SET_ACTIVE_AVATAR = graphql(`
  mutation setActiveAvatar($avatarId: String!) {
    setActiveAvatar(avatarId: $avatarId) {
      ...TProfile
    }
  }
`);

export const GENERATE_STORY_LINE = graphql(`
  mutation generateStoryLine($input: GenerateStoryLineInput!) {
    generateStoryLine(input: $input) {
      queueNum
      queueTime
    }
  }
`);
